import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

export type AdminTone =
  'azure' | 'teal' | 'indigo' | 'coral' | 'amber' | 'emerald' | 'slate' | 'rose'

interface AdminSectionProps {
  title: string
  lede?: string
  icon: LucideIcon
  tone?: AdminTone
  children: ReactNode
  actions?: ReactNode
}

export function AdminSection({
  title,
  lede,
  icon: Icon,
  tone = 'azure',
  children,
  actions,
}: AdminSectionProps) {
  return (
    <div className={`admin-section admin-section--${tone}`}>
      <header className="admin-section__header">
        <div className="admin-section__identity">
          <span className="admin-section__icon" aria-hidden>
            <Icon size={18} strokeWidth={2} />
          </span>
          <div className="admin-section__copy">
            <h2 className="admin-section__title">{title}</h2>
            {lede ? <p className="admin-section__lede">{lede}</p> : null}
          </div>
        </div>
        {actions ? <div className="admin-section__actions">{actions}</div> : null}
      </header>
      <div className="admin-section__body">{children}</div>
    </div>
  )
}
